import styles from '~/styles/components/page-components/content.module.scss';
import Link from 'next/link';
import Image from 'next/image';

import { PageWithPath } from 'types';

interface RelatedContentProps {
  page: PageWithPath;
}

export default function RelatedContent({ page }: RelatedContentProps) {

  if (!page || undefined) {
    return null;
  }
  return (
    <Link href={page?.path} target='_blank'>
      <div className={styles['content-card']}>
        <div className={styles['content-image']}>
          <Image
            src={page?.meta?.mainImage}
            alt='Content image'
            width={130}
            height={130}
            className={styles['author-img']}
            unoptimized
          />
        </div>
        <p className={styles['content-type']}>{page?.path?.split('/')?.[1]?.toUpperCase()}</p>
        <h4>{page?.displayTitle || page?.meta?.title}</h4>
      </div>
    </Link>
  );
}
